import { render } from "./InfoSquareIcon.vue?vue&type=template&id=a28fe014"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/InfoSquareIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a28fe014"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a28fe014', __exports__)) {
    api.reload('a28fe014', __exports__)
  }
  
  module.hot.accept("./InfoSquareIcon.vue?vue&type=template&id=a28fe014", () => {
    api.rerender('a28fe014', render)
  })

}


export default __exports__